import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BaseApi } from './base/base-api';
import { Observable } from 'rxjs';
import { ReviewRequest } from '../../../shared/models/dtc/reviewRequest';
import { withCache } from '@ngneat/cashew';
import { ReviewRequestResult } from '../../../shared/models/dtc/review-request-result';
import { ReviewRequestSiblings } from '../../../shared/models/review-requests/review-request-siblings';
import { ReviewRequestPropagationTarget } from '../../../shared/models/review-requests/review-request-propagation-target';

@Injectable({
  providedIn: 'root',
})
export class ReviewRequestApiService extends BaseApi {
  constructor() {
    super(environment.api + 'ReviewRequest');
  }

  public getReviewRoles(): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + '/reviewroles', {
      context: withCache(),
    });
  }

  public updateReview(review: ReviewRequest): Observable<ReviewRequestResult> {
    return this.http.put<ReviewRequestResult>(this.baseUrl, review);
  }

  public deleteReview(review: ReviewRequest): Observable<ReviewRequestResult> {
    return this.http.delete<ReviewRequestResult>(this.baseUrl + '/' + review.id);
  }

  public mergeReview(review: ReviewRequest): Observable<ReviewRequestResult> {
    return this.http.put<ReviewRequestResult>(this.baseUrl + '/merge/' + review.id, null);
  }

  public mergeSiblings(reviewRequestSiblings: ReviewRequestSiblings): Observable<ReviewRequestResult> {
    return this.http.put<ReviewRequestResult>(this.baseUrl + '/merge/siblings', reviewRequestSiblings);
  }

  public insertDtcReview(review: ReviewRequest): Observable<ReviewRequestResult> {
    return this.http.post<ReviewRequestResult>(this.baseUrl, review);
  }

  public getReviews(entityId: string): Observable<ReviewRequest[]> {
    return this.http.get<ReviewRequest[]>(this.baseUrl + '/' + entityId);
  }

  public approveDtc(entityId: string, reviewerRole: string): Observable<ReviewRequestResult> {
    return this.http.put<ReviewRequestResult>(this.baseUrl + '/approve/' + entityId, { reviewerRole: reviewerRole });
  }

  public approveDtcSiblings(siblings: ReviewRequestPropagationTarget[], reviewerRole: string): Observable<boolean> {
    return this.http.put<boolean>(this.baseUrl + '/approve/siblings', {
      siblingReviewRequestTargets: siblings,
      reviewerRole: reviewerRole,
    });
  }

  public createReviewRequestSiblings(reviewRequestSiblings: ReviewRequestSiblings): Observable<ReviewRequest[]> {
    return this.http.post<ReviewRequest[]>(this.baseUrl + '/siblings', reviewRequestSiblings);
  }

  public updateReviewRequestSiblings(reviewRequestSiblings: ReviewRequestSiblings): Observable<ReviewRequest[]> {
    return this.http.put<ReviewRequest[]>(this.baseUrl + '/siblings', reviewRequestSiblings);
  }

  public deleteReviewRequestSiblings(reviewRequestSiblings: ReviewRequestSiblings): Observable<ReviewRequest[]> {
    return this.http.delete<ReviewRequest[]>(this.baseUrl + '/siblings', { body: reviewRequestSiblings });
  }
}
